import { InsightsOutlined } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import {
  Sidebar,
  SidebarBody,
  SidebarDivider,
  SidebarFooter,
  SidebarHeader,
  SidebarHeading,
  SidebarItem,
  SidebarLabel,
  SidebarSection,
  SidebarSpacer,
} from '../../component-lib/catalyst/sidebar';
import { Avatar } from '../../component-lib/catalyst/avatar';
import Jointflows from '../../component-lib/icons/jointflows';
// import BugIcon from '../../component-lib/icons/BugIcon';
import ProjectsIcon from '../../component-lib/icons/ProjectsIcon';
import HomeIcon from '../../component-lib/icons/HomeIcon';
// import FeatureIcon from '../../component-lib/icons/FeatureIcon';
import HelpIcon from '../../component-lib/icons/HelpIcon';
// import LegalIcon from '../../component-lib/icons/LegalIcon';
import LogoutIcon from '../../component-lib/icons/LogoutIcon';
import PrioritisationIcon from '../../component-lib/icons/PrioritisationIcon';
import QueuesIcon from '../../component-lib/icons/QueuesIcon';
import TasksIcon from '../../component-lib/icons/TasksIcon';
import checkPermission from './check-permission';
import { useTenantContext } from '../../context/TenantContext';
import NotificationPopover from '../../components/NotificationPopover';
import {
  QueueListIcon,
  DocumentTextIcon,
  AdjustmentsHorizontalIcon,
  UsersIcon,
  PencilSquareIcon,
  NewspaperIcon,
  TableCellsIcon,
  BuildingOfficeIcon,
} from '@heroicons/react/24/solid';

const mainLinks = [
  {
    href: '/',
    label: 'Home',
    icon: HomeIcon,
  },
  {
    href: '/projects',
    label: 'Projects',
    checkPermission: checkPermission('view_projects_menu'),
    icon: ProjectsIcon,
  },
  {
    href: '/accounts',
    label: 'Account Plans',
    checkPermission: checkPermission('view_projects_menu'),
    icon: QueueListIcon,
  },
  // {
  //   href: '/legal',
  //   label: 'Legal',
  //   checkPermission: checkPermission('view_legal_menu'),
  //   icon: LegalIcon,
  // },
  {
    href: '/my_tasks',
    label: 'My Tasks',
    checkPermission: checkPermission('view_my_tasks_menu'),
    icon: TasksIcon,
  },
  {
    href: '/queues',
    label: 'Queues',
    checkPermission: checkPermission('view_queues_menu'),
    icon: QueuesIcon,
  },
  {
    href: '/board_priorities',
    label: 'Prioritisation',
    checkPermission: checkPermission('view_sales_prioritisation_menu'),
    icon: PrioritisationIcon,
  },
  {
    href: '/analytics',
    label: 'Analytics',
    checkPermission: checkPermission('view_analytics_menu'),
    icon: InsightsOutlined,
  },
];

const helpLinks = [
  {
    href: 'https://jointflows.ladesk.com/',
    target: '_blank',
    label: 'Help',
    icon: HelpIcon,
  },
  // {
  //   href: 'https://jointflows.canny.io/feature-requests',
  //   target: '_blank',
  //   label: 'Suggest Feature',
  //   icon: FeatureIcon,
  // },
  // {
  //   href: 'https://jointflows.ladesk.com/submit_ticket',
  //   target: '_blank',
  //   label: 'Report a Bug',
  //   icon: BugIcon,
  // },
];

const settingsLinks = [
  {
    href: '/settings/flows',
    label: 'Flows',
    icon: DocumentTextIcon,
  },
  {
    href: '/settings/playbooks',
    label: 'Playbooks',
    icon: TableCellsIcon,
  },
  {
    href: '/settings/document-library',
    label: 'Document Library',
    icon: NewspaperIcon,
  },
  {
    href: '/settings/content-library',
    label: 'Content Libray',
    icon: PencilSquareIcon,
  },
  {
    href: '/settings/users-access',
    label: 'Users & Access',
    icon: UsersIcon,
  },
  {
    href: '/settings/companies-contacts',
    label: 'Companies & Contacts',
    icon: BuildingOfficeIcon,
  },
  {
    href: '/settings/advanced',
    label: 'Advanced',
    icon: AdjustmentsHorizontalIcon,
  },
];

export default function JFSidebar({ user, permissions, logoutUser }) {
  const location = useLocation();
  const { activate_notifications } = useTenantContext();

  return (
    <Sidebar>
      <SidebarHeader>
        <SidebarSection>
          <div className="mb-2 flex h-20 flex items-center">
            <SidebarItem to="/">
              <Jointflows
                width={170}
                height={40}
              />
            </SidebarItem>
          </div>
        </SidebarSection>
      </SidebarHeader>
      <SidebarBody>
        <SidebarSection>
          {activate_notifications && <NotificationPopover />}
          {mainLinks
            .filter((link) => (link.checkPermission ? link.checkPermission(permissions) : true))
            .map((link) => {
              return (
                <SidebarItem
                  key={link.label}
                  to={link.href}
                  current={location.pathname === link.href}
                >
                  {link.icon && (
                    <link.icon
                      width={20}
                      height={20}
                    />
                  )}
                  <SidebarLabel>{link.label}</SidebarLabel>
                </SidebarItem>
              );
            })}
          <SidebarDivider />
          {helpLinks.map((link) => (
            <SidebarItem
              key={link.label}
              to={link.href}
              target="_blank"
            >
              {link.icon && (
                <link.icon
                  width={20}
                  height={20}
                />
              )}
              <SidebarLabel>{link.label}</SidebarLabel>
            </SidebarItem>
          ))}
        </SidebarSection>
        <SidebarSpacer />
        {checkPermission('view_settings_menu')(permissions) && (
          <SidebarSection>
            <SidebarHeading>Settings</SidebarHeading>
            {settingsLinks.map((link) => (
              <SidebarItem
                key={link.label}
                to={link.href}
                current={location.pathname.startsWith(link.href)}
              >
                {link.icon && (
                  <link.icon
                    width={20}
                    height={20}
                  />
                )}
                <SidebarLabel>{link.label}</SidebarLabel>
              </SidebarItem>
            ))}
          </SidebarSection>
        )}
      </SidebarBody>
      <SidebarFooter>
        <SidebarSection>
          <SidebarItem onClick={logoutUser}>
            <LogoutIcon
              width={20}
              height={20}
            />
            <SidebarLabel>Logout</SidebarLabel>
          </SidebarItem>
          <SidebarItem
            to="/profile"
            current={location.pathname === '/profile'}
          >
            <Avatar
              className="size-6"
              src={user.avatar}
              initials={user.avatar ? '' : `${user.first_name[0]}${user.last_name[0]}`}
            />
            <SidebarLabel>
              {user.first_name} {user.last_name}
            </SidebarLabel>
          </SidebarItem>
        </SidebarSection>
      </SidebarFooter>
    </Sidebar>
  );
}
